import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing }) => ({
  section: {
    flexDirection: "column",
    marginBottom: {
      xs: spacing(6),
      lg: spacing(14),
    },
    gap: {
      xs: spacing(2),
      lg: spacing(4),
    },
  },
}));

export default stylesheet;
